import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
};

export type Query = {
  __typename?: 'Query';
  version: Scalars['String'];
  userinformation: UserInformation;
  dummyEnumQuery?: Maybe<DummyEnumResponse>;
  questionForDataGroupById?: Maybe<Array<GenestoryQuestion>>;
  questionsForDataGroupByType: Array<GenestoryQuestion>;
  geneDataGroups: Array<GeneDataGroup>;
  geneDataGroupById: GeneDataGroup;
  geneDataGroupByType: GeneDataGroup;
  geneStories: Array<GeneStory>;
  genestoryById: GeneStory;
  genestoryByName: GeneStory;
  nutrients: Array<Nutrient>;
  nutrientValuesForDataGroup: Array<Nutrient>;
  nutrientsToIncrease: Array<NutrientsResponse>;
  nutrientsToDecrease: Array<NutrientsResponse>;
  storydataForQuestion: StoryDataResponse;
  storyRecommendationForQuestion: StoryRecommendationResponse;
  genesForQuestion: Array<Gene>;
  nutrientsForQuestion: Array<NutrientsResponse>;
  demoreport: DnaReport;
  userreport?: Maybe<DnaReport>;
  user: User;
  micronutrients: Array<NutrientsResponse>;
  userFavourites: Array<UserFavouritesResponse>;
  isUserFavourite: Scalars['Boolean'];
  genePopulationsByReport: Array<GenePopulationResponse>;
  overview: OverviewResponse;
  getNutrientInfo?: Maybe<NutrientInfoWithSource>;
  resilience: ResilienceResponse;
  geneDataGroupSourcesByType: Array<GeneDataGroupSource>;
};


export type QueryQuestionForDataGroupByIdArgs = {
  id: Scalars['ID'];
};


export type QueryQuestionsForDataGroupByTypeArgs = {
  demo?: Maybe<Scalars['Boolean']>;
  types: Array<GeneDataGroupType>;
};


export type QueryGeneDataGroupByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGeneDataGroupByTypeArgs = {
  type: GeneDataGroupType;
};


export type QueryGenestoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGenestoryByNameArgs = {
  name: Scalars['String'];
};


export type QueryNutrientValuesForDataGroupArgs = {
  id: Scalars['ID'];
};


export type QueryNutrientsToIncreaseArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryNutrientsToDecreaseArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryStorydataForQuestionArgs = {
  demo?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
};


export type QueryStoryRecommendationForQuestionArgs = {
  demo?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
};


export type QueryGenesForQuestionArgs = {
  demo?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
};


export type QueryNutrientsForQuestionArgs = {
  demo?: Maybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
};


export type QueryMicronutrientsArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryIsUserFavouriteArgs = {
  index: Scalars['Int'];
  subcategory: Scalars['String'];
  category: Scalars['String'];
};


export type QueryGenePopulationsByReportArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryOverviewArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryGetNutrientInfoArgs = {
  name: Scalars['String'];
};


export type QueryResilienceArgs = {
  demo?: Maybe<Scalars['Boolean']>;
};


export type QueryGeneDataGroupSourcesByTypeArgs = {
  type: GeneDataGroupType;
};

export type UserInformation = {
  __typename?: 'UserInformation';
  id: Scalars['ID'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  gender: Gender;
  weight: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  height: Scalars['String'];
  ethnicity: Ethnicity;
  dietPreference: DietPreference;
  userId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
};

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}


export enum Ethnicity {
  EUROPEAN = 'EUROPEAN',
  AFRICAN = 'AFRICAN',
  ARABIC = 'ARABIC',
  ASIAN = 'ASIAN',
  HISPANIC = 'HISPANIC',
  MIXED = 'MIXED'
}

export enum DietPreference {
  STANDARD = 'STANDARD',
  PESCATARIAN = 'PESCATARIAN',
  VEGETERIAN = 'VEGETERIAN',
  VEGAN = 'VEGAN'
}

export type DummyEnumResponse = {
  __typename?: 'DummyEnumResponse';
  loginError: LoginError;
  userInformationError: UserInformationError;
  registerError: RegisterError;
  verifyCodeError: VerifyCodeError;
  passwordResetError: PasswordResetError;
  updatePasswordError: UpdatePasswordError;
  geneDataGroupType: GeneDataGroupType;
  geneDataGroupArea: GeneDataGroupArea;
  feedbackType: FeedbackType;
  gender: Gender;
  ethnicity: Ethnicity;
  dietPreference: DietPreference;
};

export enum LoginError {
  UNKNOWN_USER = 'UNKNOWN_USER',
  CREDENTIALS_INVALID = 'CREDENTIALS_INVALID'
}

export enum UserInformationError {
  EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND'
}

export enum RegisterError {
  INVALID_DATA = 'INVALID_DATA',
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE'
}

export enum VerifyCodeError {
  CODE_INVALID = 'CODE_INVALID'
}

export enum PasswordResetError {
  UNKNOWN_USER = 'UNKNOWN_USER'
}

export enum UpdatePasswordError {
  INVALID_PASSWORD = 'INVALID_PASSWORD'
}

export enum GeneDataGroupType {
  HEART = 'HEART',
  BRAIN = 'BRAIN',
  BONE = 'BONE',
  JOINT = 'JOINT',
  EYE = 'EYE',
  OXIDATIVESTRESS = 'OXIDATIVESTRESS',
  METABOLISM = 'METABOLISM',
  DETOX = 'DETOX',
  GLUTEN = 'GLUTEN',
  LACTOSE = 'LACTOSE',
  HOMOCYSTEINE = 'HOMOCYSTEINE',
  HOMOCYSTEINE_B2 = 'HOMOCYSTEINE_B2',
  HYPERTENSION = 'HYPERTENSION',
  TOTAL = 'TOTAL',
  MICRONUTRIENTS = 'MICRONUTRIENTS',
  RDA = 'RDA',
  RESILIENCE = 'RESILIENCE'
}

export enum GeneDataGroupArea {
  ORGANS = 'ORGANS',
  METABOLISM = 'METABOLISM',
  DIET = 'DIET',
  BLOOD = 'BLOOD',
  TOTAL = 'TOTAL',
  MICRONUTRIENTS = 'MICRONUTRIENTS',
  MENTAL_HEALTH = 'MENTAL_HEALTH'
}

export enum FeedbackType {
  STORYDATA = 'STORYDATA',
  STORYRECOMMENDATION = 'STORYRECOMMENDATION',
  GENES = 'GENES',
  NUTRIENTS = 'NUTRIENTS',
  NUTRIENTS_TO_INCREASE = 'NUTRIENTS_TO_INCREASE',
  NUTRIENTS_TO_DECREASE = 'NUTRIENTS_TO_DECREASE',
  INTRODUCTION = 'INTRODUCTION',
  MICRONUTRIENTS = 'MICRONUTRIENTS',
  RESILIENCE = 'RESILIENCE',
  GENE_INFO = 'GENE_INFO',
  GENE_RISK_INFO = 'GENE_RISK_INFO'
}

export type GenestoryQuestion = {
  __typename?: 'GenestoryQuestion';
  id: Scalars['ID'];
  question: Scalars['String'];
  feedbackType: FeedbackType;
  genestoryId?: Maybe<Scalars['ID']>;
  geneDataGroupId: Scalars['ID'];
};

export type GeneDataGroup = {
  __typename?: 'GeneDataGroup';
  id: Scalars['ID'];
  type: Scalars['String'];
  area: Scalars['String'];
  nutrientArrowName: Scalars['String'];
};

export type GeneStory = {
  __typename?: 'GeneStory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Nutrient = {
  __typename?: 'Nutrient';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type NutrientsResponse = {
  __typename?: 'NutrientsResponse';
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
  rda?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  personalRda?: Maybe<Scalars['String']>;
  geneDataGroups: Array<GeneDataGroupType>;
  sources: Array<NutrientSource>;
};

export type NutrientSource = {
  __typename?: 'NutrientSource';
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  isVegan: Scalars['Boolean'];
  isVegeterian: Scalars['Boolean'];
  isPescatarian: Scalars['Boolean'];
};

export type StoryDataResponse = {
  __typename?: 'StoryDataResponse';
  description: Scalars['String'];
  genestoryResult: Scalars['String'];
  badImage: Scalars['String'];
  goodImage: Scalars['String'];
};

export type StoryRecommendationResponse = {
  __typename?: 'StoryRecommendationResponse';
  text: Scalars['String'];
  result: Scalars['String'];
};

export type Gene = {
  __typename?: 'Gene';
  id: Scalars['ID'];
  name: Scalars['String'];
  refsnp: Scalars['String'];
  genotype: Scalars['String'];
  orientation?: Maybe<Scalars['String']>;
  geneDataGroupId: Scalars['String'];
  dnaReportId: Scalars['String'];
};

export type DnaReport = {
  __typename?: 'DnaReport';
  id: Scalars['ID'];
  orderId: Scalars['String'];
  emailId: Scalars['String'];
  emailSent: Scalars['Boolean'];
  isDemo: Scalars['Boolean'];
  reportedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  emailId: Scalars['String'];
  onboardedAt?: Maybe<Scalars['DateTime']>;
  dnaReport?: Maybe<DnaReport>;
};


export type UserDnaReportArgs = {
  useDemoIfNoReportAvailable: Scalars['Boolean'];
};

export type UserFavouritesResponse = {
  __typename?: 'UserFavouritesResponse';
  category: Scalars['String'];
  subcategory: Scalars['String'];
  index: Scalars['Int'];
};

export type GenePopulationResponse = {
  __typename?: 'GenePopulationResponse';
  index: Scalars['Int'];
  geneDataGroup: GeneDataGroupType;
  geneName: Scalars['String'];
  geneRefsnp: Scalars['String'];
  genoType: Scalars['String'];
  population?: Maybe<Scalars['Int']>;
  orientation: Scalars['String'];
  references: Array<Scalars['String']>;
};

export type OverviewResponse = {
  __typename?: 'OverviewResponse';
  caffeine: CaffeineBreakdown;
  lactose: Intolerance;
  gluten: Intolerance;
};

export enum CaffeineBreakdown {
  SLOW = 'SLOW',
  NORMAL = 'NORMAL'
}

export enum Intolerance {
  NO_RISK = 'NO_RISK',
  MODERATE_RISK = 'MODERATE_RISK',
  HIGH_RISK = 'HIGH_RISK'
}

export type NutrientInfoWithSource = {
  __typename?: 'NutrientInfoWithSource';
  id: Scalars['ID'];
  locale: Scalars['String'];
  nutrient: Nutrient;
  info: Scalars['String'];
  foodSourcesHeader: Scalars['String'];
  foodSources: Array<NutrientSource>;
  functionsHeader: Scalars['String'];
  bioAvailabilityHeader: Scalars['String'];
  bioAvailability: Scalars['String'];
  foodPreparationHeader: Scalars['String'];
  foodPreparation: Scalars['String'];
  referencesHeader: Scalars['String'];
  references: Array<Scalars['String']>;
};

export type ResilienceResponse = {
  __typename?: 'ResilienceResponse';
  stress: ResilienceLevel;
  emotion: ResilienceLevel;
  impulsiveness: ResilienceLevel;
};

export enum ResilienceLevel {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL',
  LOW = 'LOW',
  NONE = 'NONE'
}

export type GeneDataGroupSource = {
  __typename?: 'GeneDataGroupSource';
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  isVegan: Scalars['Boolean'];
  isVegeterian: Scalars['Boolean'];
  isPescatarian: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  register: RegisterResponse;
  renewCode: Scalars['Boolean'];
  verifyCode: VerifyCodeResponse;
  login: LoginResponse;
  resetPassword: Scalars['String'];
  changePassword: ChangePasswordResponse;
  updatePassword: UpdatePasswordResponse;
  createUserInformation: UserInformation;
  updateUserInformation: UserInformation;
  updateUserFavourite: Scalars['Boolean'];
};


export type MutationRegisterArgs = {
  lastName: Scalars['String'];
  firstName: Scalars['String'];
  password: Scalars['String'];
  email: Scalars['String'];
};


export type MutationVerifyCodeArgs = {
  code: Scalars['String'];
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  password: Scalars['String'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCreateUserInformationArgs = {
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  gender: Gender;
  weight: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  height: Scalars['String'];
  ethnicity: Ethnicity;
  dietPreference: DietPreference;
};


export type MutationUpdateUserInformationArgs = {
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  gender: Gender;
  weight: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  height: Scalars['String'];
  ethnicity: Ethnicity;
  dietPreference: DietPreference;
};


export type MutationUpdateUserFavouriteArgs = {
  index: Scalars['Int'];
  subcategory: Scalars['String'];
  category: Scalars['String'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  user?: Maybe<User>;
  token: Scalars['String'];
};

export type VerifyCodeResponse = {
  __typename?: 'VerifyCodeResponse';
  token: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  token: Scalars['String'];
};

export type UpdatePasswordResponse = {
  __typename?: 'UpdatePasswordResponse';
  success: Scalars['Boolean'];
};

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword: (
    { __typename?: 'ChangePasswordResponse' }
    & Pick<ChangePasswordResponse, 'token'>
  ) }
);

export type CreateUserInformationMutationVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  gender: Gender;
  ethnicity: Ethnicity;
  weight: Scalars['String'];
  height: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  dietPreference: DietPreference;
}>;


export type CreateUserInformationMutation = (
  { __typename?: 'Mutation' }
  & { createUserInformation: (
    { __typename?: 'UserInformation' }
    & Pick<UserInformation, 'userId'>
  ) }
);

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'LoginResponse' }
    & Pick<LoginResponse, 'token'>
  ) }
);

export type RegisterMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
}>;


export type RegisterMutation = (
  { __typename?: 'Mutation' }
  & { register: (
    { __typename?: 'RegisterResponse' }
    & Pick<RegisterResponse, 'token'>
  ) }
);

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type UpdatePasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = (
  { __typename?: 'Mutation' }
  & { updatePassword: (
    { __typename?: 'UpdatePasswordResponse' }
    & Pick<UpdatePasswordResponse, 'success'>
  ) }
);

export type UpdateUserFavouriteMutationVariables = Exact<{
  category: Scalars['String'];
  subcategory: Scalars['String'];
  index: Scalars['Int'];
}>;


export type UpdateUserFavouriteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateUserFavourite'>
);

export type UpdateUserInformationMutationVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  gender: Gender;
  ethnicity: Ethnicity;
  weight: Scalars['String'];
  height: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  dietPreference: DietPreference;
}>;


export type UpdateUserInformationMutation = (
  { __typename?: 'Mutation' }
  & { updateUserInformation: (
    { __typename?: 'UserInformation' }
    & Pick<UserInformation, 'userId'>
  ) }
);

export type VerifyCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type VerifyCodeMutation = (
  { __typename?: 'Mutation' }
  & { verifyCode: (
    { __typename?: 'VerifyCodeResponse' }
    & Pick<VerifyCodeResponse, 'token'>
  ) }
);

export type DemoreportQueryVariables = Exact<{ [key: string]: never; }>;


export type DemoreportQuery = (
  { __typename?: 'Query' }
  & { demoreport: (
    { __typename?: 'DnaReport' }
    & Pick<DnaReport, 'id' | 'orderId' | 'emailId'>
  ) }
);

export type DummyEnumQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DummyEnumQueryQuery = (
  { __typename?: 'Query' }
  & { dummyEnumQuery?: Maybe<(
    { __typename?: 'DummyEnumResponse' }
    & Pick<DummyEnumResponse, 'loginError' | 'registerError' | 'verifyCodeError' | 'passwordResetError' | 'geneDataGroupType' | 'geneDataGroupArea' | 'feedbackType' | 'gender' | 'ethnicity'>
  )> }
);

export type GeneDataGroupSourcesQueryVariables = Exact<{
  type: GeneDataGroupType;
}>;


export type GeneDataGroupSourcesQuery = (
  { __typename?: 'Query' }
  & { geneDataGroupSourcesByType: Array<(
    { __typename?: 'GeneDataGroupSource' }
    & Pick<GeneDataGroupSource, 'isPescatarian' | 'isVegan' | 'isVegeterian' | 'name' | 'sortOrder'>
  )> }
);

export type GenePopulationsByReportQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type GenePopulationsByReportQuery = (
  { __typename?: 'Query' }
  & { genePopulationsByReport: Array<(
    { __typename?: 'GenePopulationResponse' }
    & Pick<GenePopulationResponse, 'index' | 'geneDataGroup' | 'geneName' | 'geneRefsnp' | 'genoType' | 'population' | 'orientation' | 'references'>
  )> }
);

export type GenesForQuestionQueryVariables = Exact<{
  questionId: Scalars['ID'];
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type GenesForQuestionQuery = (
  { __typename?: 'Query' }
  & { genesForQuestion: Array<(
    { __typename?: 'Gene' }
    & Pick<Gene, 'id' | 'name' | 'refsnp' | 'genotype' | 'orientation' | 'geneDataGroupId' | 'dnaReportId'>
  )> }
);

export type GetNutrientInfoQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetNutrientInfoQuery = (
  { __typename?: 'Query' }
  & { getNutrientInfo?: Maybe<(
    { __typename?: 'NutrientInfoWithSource' }
    & Pick<NutrientInfoWithSource, 'id' | 'locale' | 'info' | 'foodSourcesHeader' | 'functionsHeader' | 'bioAvailabilityHeader' | 'bioAvailability' | 'foodPreparationHeader' | 'foodPreparation' | 'referencesHeader' | 'references'>
    & { nutrient: (
      { __typename?: 'Nutrient' }
      & Pick<Nutrient, 'id' | 'name'>
    ), foodSources: Array<(
      { __typename?: 'NutrientSource' }
      & Pick<NutrientSource, 'name' | 'sortOrder' | 'isVegan' | 'isVegeterian' | 'isPescatarian'>
    )> }
  )> }
);

export type IsUserFavouriteQueryVariables = Exact<{
  category: Scalars['String'];
  subcategory: Scalars['String'];
  index: Scalars['Int'];
}>;


export type IsUserFavouriteQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isUserFavourite'>
);

export type MicronutrientsQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type MicronutrientsQuery = (
  { __typename?: 'Query' }
  & { micronutrients: Array<(
    { __typename?: 'NutrientsResponse' }
    & Pick<NutrientsResponse, 'id' | 'name' | 'personalRda' | 'rda' | 'unit' | 'value' | 'geneDataGroups'>
    & { sources: Array<(
      { __typename?: 'NutrientSource' }
      & Pick<NutrientSource, 'name' | 'sortOrder' | 'isVegan' | 'isVegeterian' | 'isPescatarian'>
    )> }
  )> }
);

export type NutrientsForQuestionQueryVariables = Exact<{
  questionId: Scalars['ID'];
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type NutrientsForQuestionQuery = (
  { __typename?: 'Query' }
  & { nutrientsForQuestion: Array<(
    { __typename?: 'NutrientsResponse' }
    & Pick<NutrientsResponse, 'id' | 'name' | 'value' | 'rda' | 'unit' | 'personalRda' | 'geneDataGroups'>
    & { sources: Array<(
      { __typename?: 'NutrientSource' }
      & Pick<NutrientSource, 'name' | 'sortOrder' | 'isVegan' | 'isVegeterian' | 'isPescatarian'>
    )> }
  )> }
);

export type NutrientsToDecreaseQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type NutrientsToDecreaseQuery = (
  { __typename?: 'Query' }
  & { nutrientsToDecrease: Array<(
    { __typename?: 'NutrientsResponse' }
    & Pick<NutrientsResponse, 'id' | 'name' | 'personalRda' | 'rda' | 'unit' | 'value' | 'geneDataGroups'>
    & { sources: Array<(
      { __typename?: 'NutrientSource' }
      & Pick<NutrientSource, 'name' | 'sortOrder' | 'isVegan' | 'isVegeterian' | 'isPescatarian'>
    )> }
  )> }
);

export type NutrientsToIncreaseQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type NutrientsToIncreaseQuery = (
  { __typename?: 'Query' }
  & { nutrientsToIncrease: Array<(
    { __typename?: 'NutrientsResponse' }
    & Pick<NutrientsResponse, 'id' | 'name' | 'personalRda' | 'rda' | 'unit' | 'value' | 'geneDataGroups'>
    & { sources: Array<(
      { __typename?: 'NutrientSource' }
      & Pick<NutrientSource, 'name' | 'sortOrder' | 'isVegan' | 'isVegeterian' | 'isPescatarian'>
    )> }
  )> }
);

export type OverviewQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type OverviewQuery = (
  { __typename?: 'Query' }
  & { overview: (
    { __typename?: 'OverviewResponse' }
    & Pick<OverviewResponse, 'caffeine' | 'lactose' | 'gluten'>
  ) }
);

export type QuestionsForDataGroupByTypeQueryVariables = Exact<{
  types: Array<GeneDataGroupType> | GeneDataGroupType;
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type QuestionsForDataGroupByTypeQuery = (
  { __typename?: 'Query' }
  & { questionsForDataGroupByType: Array<(
    { __typename?: 'GenestoryQuestion' }
    & Pick<GenestoryQuestion, 'id' | 'question' | 'feedbackType' | 'genestoryId' | 'geneDataGroupId'>
  )> }
);

export type ResilienceQueryVariables = Exact<{
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type ResilienceQuery = (
  { __typename?: 'Query' }
  & { resilience: (
    { __typename?: 'ResilienceResponse' }
    & Pick<ResilienceResponse, 'emotion' | 'impulsiveness' | 'stress'>
  ) }
);

export type StoryRecommendationForQuestionQueryVariables = Exact<{
  questionId: Scalars['ID'];
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type StoryRecommendationForQuestionQuery = (
  { __typename?: 'Query' }
  & { storyRecommendationForQuestion: (
    { __typename?: 'StoryRecommendationResponse' }
    & Pick<StoryRecommendationResponse, 'text' | 'result'>
  ) }
);

export type StorydataForQuestionQueryVariables = Exact<{
  questionId: Scalars['ID'];
  demo?: Maybe<Scalars['Boolean']>;
}>;


export type StorydataForQuestionQuery = (
  { __typename?: 'Query' }
  & { storydataForQuestion: (
    { __typename?: 'StoryDataResponse' }
    & Pick<StoryDataResponse, 'description' | 'genestoryResult' | 'badImage' | 'goodImage'>
  ) }
);

export type UserFavouritesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFavouritesQuery = (
  { __typename?: 'Query' }
  & { userFavourites: Array<(
    { __typename?: 'UserFavouritesResponse' }
    & Pick<UserFavouritesResponse, 'category' | 'subcategory' | 'index'>
  )> }
);

export type UserInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInformationQuery = (
  { __typename?: 'Query' }
  & { userinformation: (
    { __typename?: 'UserInformation' }
    & Pick<UserInformation, 'id' | 'firstname' | 'lastname' | 'gender' | 'weight' | 'dateOfBirth' | 'height' | 'ethnicity' | 'userId' | 'dietPreference' | 'email'>
  ) }
);

export type UserreportQueryVariables = Exact<{ [key: string]: never; }>;


export type UserreportQuery = (
  { __typename?: 'Query' }
  & { userreport?: Maybe<(
    { __typename?: 'DnaReport' }
    & Pick<DnaReport, 'id' | 'orderId' | 'emailId'>
  )> }
);

export type UserQueryVariables = Exact<{
  useDemoIfNoReportAvailable: Scalars['Boolean'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'emailId' | 'onboardedAt'>
    & { dnaReport?: Maybe<(
      { __typename?: 'DnaReport' }
      & Pick<DnaReport, 'id' | 'orderId' | 'emailId' | 'emailSent' | 'isDemo' | 'reportedAt' | 'createdAt'>
    )> }
  ) }
);


export const ChangePasswordDocument = gql`
    mutation changePassword($password: String!) {
  changePassword(password: $password) {
    token
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateUserInformationDocument = gql`
    mutation createUserInformation($firstname: String!, $lastname: String!, $gender: Gender!, $ethnicity: Ethnicity!, $weight: String!, $height: String!, $dateOfBirth: DateTime!, $dietPreference: DietPreference!) {
  createUserInformation(
    firstname: $firstname
    lastname: $lastname
    gender: $gender
    ethnicity: $ethnicity
    weight: $weight
    height: $height
    dateOfBirth: $dateOfBirth
    dietPreference: $dietPreference
  ) {
    userId
  }
}
    `;
export type CreateUserInformationMutationFn = Apollo.MutationFunction<CreateUserInformationMutation, CreateUserInformationMutationVariables>;

/**
 * __useCreateUserInformationMutation__
 *
 * To run a mutation, you first call `useCreateUserInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserInformationMutation, { data, loading, error }] = useCreateUserInformationMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      gender: // value for 'gender'
 *      ethnicity: // value for 'ethnicity'
 *      weight: // value for 'weight'
 *      height: // value for 'height'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      dietPreference: // value for 'dietPreference'
 *   },
 * });
 */
export function useCreateUserInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserInformationMutation, CreateUserInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserInformationMutation, CreateUserInformationMutationVariables>(CreateUserInformationDocument, options);
      }
export type CreateUserInformationMutationHookResult = ReturnType<typeof useCreateUserInformationMutation>;
export type CreateUserInformationMutationResult = Apollo.MutationResult<CreateUserInformationMutation>;
export type CreateUserInformationMutationOptions = Apollo.BaseMutationOptions<CreateUserInformationMutation, CreateUserInformationMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($email: String!, $firstName: String!, $lastName: String!, $password: String!) {
  register(
    email: $email
    firstName: $firstName
    lastName: $lastName
    password: $password
  ) {
    token
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  resetPassword(email: $email)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($newPassword: String!, $oldPassword: String!) {
  updatePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    success
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserFavouriteDocument = gql`
    mutation updateUserFavourite($category: String!, $subcategory: String!, $index: Int!) {
  updateUserFavourite(
    category: $category
    subcategory: $subcategory
    index: $index
  )
}
    `;
export type UpdateUserFavouriteMutationFn = Apollo.MutationFunction<UpdateUserFavouriteMutation, UpdateUserFavouriteMutationVariables>;

/**
 * __useUpdateUserFavouriteMutation__
 *
 * To run a mutation, you first call `useUpdateUserFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFavouriteMutation, { data, loading, error }] = useUpdateUserFavouriteMutation({
 *   variables: {
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useUpdateUserFavouriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserFavouriteMutation, UpdateUserFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserFavouriteMutation, UpdateUserFavouriteMutationVariables>(UpdateUserFavouriteDocument, options);
      }
export type UpdateUserFavouriteMutationHookResult = ReturnType<typeof useUpdateUserFavouriteMutation>;
export type UpdateUserFavouriteMutationResult = Apollo.MutationResult<UpdateUserFavouriteMutation>;
export type UpdateUserFavouriteMutationOptions = Apollo.BaseMutationOptions<UpdateUserFavouriteMutation, UpdateUserFavouriteMutationVariables>;
export const UpdateUserInformationDocument = gql`
    mutation updateUserInformation($firstname: String!, $lastname: String!, $gender: Gender!, $ethnicity: Ethnicity!, $weight: String!, $height: String!, $dateOfBirth: DateTime!, $dietPreference: DietPreference!) {
  updateUserInformation(
    firstname: $firstname
    lastname: $lastname
    gender: $gender
    ethnicity: $ethnicity
    weight: $weight
    height: $height
    dateOfBirth: $dateOfBirth
    dietPreference: $dietPreference
  ) {
    userId
  }
}
    `;
export type UpdateUserInformationMutationFn = Apollo.MutationFunction<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;

/**
 * __useUpdateUserInformationMutation__
 *
 * To run a mutation, you first call `useUpdateUserInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInformationMutation, { data, loading, error }] = useUpdateUserInformationMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      gender: // value for 'gender'
 *      ethnicity: // value for 'ethnicity'
 *      weight: // value for 'weight'
 *      height: // value for 'height'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      dietPreference: // value for 'dietPreference'
 *   },
 * });
 */
export function useUpdateUserInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>(UpdateUserInformationDocument, options);
      }
export type UpdateUserInformationMutationHookResult = ReturnType<typeof useUpdateUserInformationMutation>;
export type UpdateUserInformationMutationResult = Apollo.MutationResult<UpdateUserInformationMutation>;
export type UpdateUserInformationMutationOptions = Apollo.BaseMutationOptions<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;
export const VerifyCodeDocument = gql`
    mutation verifyCode($code: String!) {
  verifyCode(code: $code) {
    token
  }
}
    `;
export type VerifyCodeMutationFn = Apollo.MutationFunction<VerifyCodeMutation, VerifyCodeMutationVariables>;

/**
 * __useVerifyCodeMutation__
 *
 * To run a mutation, you first call `useVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCodeMutation, { data, loading, error }] = useVerifyCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyCodeMutation, VerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyCodeMutation, VerifyCodeMutationVariables>(VerifyCodeDocument, options);
      }
export type VerifyCodeMutationHookResult = ReturnType<typeof useVerifyCodeMutation>;
export type VerifyCodeMutationResult = Apollo.MutationResult<VerifyCodeMutation>;
export type VerifyCodeMutationOptions = Apollo.BaseMutationOptions<VerifyCodeMutation, VerifyCodeMutationVariables>;
export const DemoreportDocument = gql`
    query demoreport {
  demoreport {
    id
    orderId
    emailId
  }
}
    `;

/**
 * __useDemoreportQuery__
 *
 * To run a query within a React component, call `useDemoreportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDemoreportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDemoreportQuery({
 *   variables: {
 *   },
 * });
 */
export function useDemoreportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DemoreportQuery, DemoreportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DemoreportQuery, DemoreportQueryVariables>(DemoreportDocument, options);
      }
export function useDemoreportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DemoreportQuery, DemoreportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DemoreportQuery, DemoreportQueryVariables>(DemoreportDocument, options);
        }
export type DemoreportQueryHookResult = ReturnType<typeof useDemoreportQuery>;
export type DemoreportLazyQueryHookResult = ReturnType<typeof useDemoreportLazyQuery>;
export type DemoreportQueryResult = Apollo.QueryResult<DemoreportQuery, DemoreportQueryVariables>;
export const DummyEnumQueryDocument = gql`
    query dummyEnumQuery {
  dummyEnumQuery {
    loginError
    registerError
    verifyCodeError
    passwordResetError
    geneDataGroupType
    geneDataGroupArea
    feedbackType
    gender
    ethnicity
  }
}
    `;

/**
 * __useDummyEnumQueryQuery__
 *
 * To run a query within a React component, call `useDummyEnumQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDummyEnumQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDummyEnumQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDummyEnumQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DummyEnumQueryQuery, DummyEnumQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DummyEnumQueryQuery, DummyEnumQueryQueryVariables>(DummyEnumQueryDocument, options);
      }
export function useDummyEnumQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DummyEnumQueryQuery, DummyEnumQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DummyEnumQueryQuery, DummyEnumQueryQueryVariables>(DummyEnumQueryDocument, options);
        }
export type DummyEnumQueryQueryHookResult = ReturnType<typeof useDummyEnumQueryQuery>;
export type DummyEnumQueryLazyQueryHookResult = ReturnType<typeof useDummyEnumQueryLazyQuery>;
export type DummyEnumQueryQueryResult = Apollo.QueryResult<DummyEnumQueryQuery, DummyEnumQueryQueryVariables>;
export const GeneDataGroupSourcesDocument = gql`
    query GeneDataGroupSources($type: GeneDataGroupType!) {
  geneDataGroupSourcesByType(type: $type) {
    isPescatarian
    isVegan
    isVegeterian
    name
    sortOrder
  }
}
    `;

/**
 * __useGeneDataGroupSourcesQuery__
 *
 * To run a query within a React component, call `useGeneDataGroupSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneDataGroupSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneDataGroupSourcesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGeneDataGroupSourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GeneDataGroupSourcesQuery, GeneDataGroupSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GeneDataGroupSourcesQuery, GeneDataGroupSourcesQueryVariables>(GeneDataGroupSourcesDocument, options);
      }
export function useGeneDataGroupSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneDataGroupSourcesQuery, GeneDataGroupSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GeneDataGroupSourcesQuery, GeneDataGroupSourcesQueryVariables>(GeneDataGroupSourcesDocument, options);
        }
export type GeneDataGroupSourcesQueryHookResult = ReturnType<typeof useGeneDataGroupSourcesQuery>;
export type GeneDataGroupSourcesLazyQueryHookResult = ReturnType<typeof useGeneDataGroupSourcesLazyQuery>;
export type GeneDataGroupSourcesQueryResult = Apollo.QueryResult<GeneDataGroupSourcesQuery, GeneDataGroupSourcesQueryVariables>;
export const GenePopulationsByReportDocument = gql`
    query genePopulationsByReport($demo: Boolean) {
  genePopulationsByReport(demo: $demo) {
    index
    geneDataGroup
    geneName
    geneRefsnp
    genoType
    population
    orientation
    references
  }
}
    `;

/**
 * __useGenePopulationsByReportQuery__
 *
 * To run a query within a React component, call `useGenePopulationsByReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenePopulationsByReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenePopulationsByReportQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useGenePopulationsByReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GenePopulationsByReportQuery, GenePopulationsByReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenePopulationsByReportQuery, GenePopulationsByReportQueryVariables>(GenePopulationsByReportDocument, options);
      }
export function useGenePopulationsByReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenePopulationsByReportQuery, GenePopulationsByReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenePopulationsByReportQuery, GenePopulationsByReportQueryVariables>(GenePopulationsByReportDocument, options);
        }
export type GenePopulationsByReportQueryHookResult = ReturnType<typeof useGenePopulationsByReportQuery>;
export type GenePopulationsByReportLazyQueryHookResult = ReturnType<typeof useGenePopulationsByReportLazyQuery>;
export type GenePopulationsByReportQueryResult = Apollo.QueryResult<GenePopulationsByReportQuery, GenePopulationsByReportQueryVariables>;
export const GenesForQuestionDocument = gql`
    query genesForQuestion($questionId: ID!, $demo: Boolean) {
  genesForQuestion(questionId: $questionId, demo: $demo) {
    id
    name
    refsnp
    genotype
    orientation
    geneDataGroupId
    dnaReportId
  }
}
    `;

/**
 * __useGenesForQuestionQuery__
 *
 * To run a query within a React component, call `useGenesForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenesForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenesForQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useGenesForQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenesForQuestionQuery, GenesForQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenesForQuestionQuery, GenesForQuestionQueryVariables>(GenesForQuestionDocument, options);
      }
export function useGenesForQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenesForQuestionQuery, GenesForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenesForQuestionQuery, GenesForQuestionQueryVariables>(GenesForQuestionDocument, options);
        }
export type GenesForQuestionQueryHookResult = ReturnType<typeof useGenesForQuestionQuery>;
export type GenesForQuestionLazyQueryHookResult = ReturnType<typeof useGenesForQuestionLazyQuery>;
export type GenesForQuestionQueryResult = Apollo.QueryResult<GenesForQuestionQuery, GenesForQuestionQueryVariables>;
export const GetNutrientInfoDocument = gql`
    query GetNutrientInfo($name: String!) {
  getNutrientInfo(name: $name) {
    id
    locale
    nutrient {
      id
      name
    }
    info
    foodSourcesHeader
    foodSources {
      name
      sortOrder
      isVegan
      isVegeterian
      isPescatarian
    }
    functionsHeader
    bioAvailabilityHeader
    bioAvailability
    foodPreparationHeader
    foodPreparation
    referencesHeader
    references
  }
}
    `;

/**
 * __useGetNutrientInfoQuery__
 *
 * To run a query within a React component, call `useGetNutrientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNutrientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNutrientInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetNutrientInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNutrientInfoQuery, GetNutrientInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNutrientInfoQuery, GetNutrientInfoQueryVariables>(GetNutrientInfoDocument, options);
      }
export function useGetNutrientInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNutrientInfoQuery, GetNutrientInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNutrientInfoQuery, GetNutrientInfoQueryVariables>(GetNutrientInfoDocument, options);
        }
export type GetNutrientInfoQueryHookResult = ReturnType<typeof useGetNutrientInfoQuery>;
export type GetNutrientInfoLazyQueryHookResult = ReturnType<typeof useGetNutrientInfoLazyQuery>;
export type GetNutrientInfoQueryResult = Apollo.QueryResult<GetNutrientInfoQuery, GetNutrientInfoQueryVariables>;
export const IsUserFavouriteDocument = gql`
    query isUserFavourite($category: String!, $subcategory: String!, $index: Int!) {
  isUserFavourite(category: $category, subcategory: $subcategory, index: $index)
}
    `;

/**
 * __useIsUserFavouriteQuery__
 *
 * To run a query within a React component, call `useIsUserFavouriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserFavouriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserFavouriteQuery({
 *   variables: {
 *      category: // value for 'category'
 *      subcategory: // value for 'subcategory'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useIsUserFavouriteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsUserFavouriteQuery, IsUserFavouriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsUserFavouriteQuery, IsUserFavouriteQueryVariables>(IsUserFavouriteDocument, options);
      }
export function useIsUserFavouriteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsUserFavouriteQuery, IsUserFavouriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsUserFavouriteQuery, IsUserFavouriteQueryVariables>(IsUserFavouriteDocument, options);
        }
export type IsUserFavouriteQueryHookResult = ReturnType<typeof useIsUserFavouriteQuery>;
export type IsUserFavouriteLazyQueryHookResult = ReturnType<typeof useIsUserFavouriteLazyQuery>;
export type IsUserFavouriteQueryResult = Apollo.QueryResult<IsUserFavouriteQuery, IsUserFavouriteQueryVariables>;
export const MicronutrientsDocument = gql`
    query micronutrients($demo: Boolean) {
  micronutrients(demo: $demo) {
    id
    name
    personalRda
    rda
    unit
    value
    geneDataGroups
    sources {
      name
      sortOrder
      isVegan
      isVegeterian
      isPescatarian
    }
  }
}
    `;

/**
 * __useMicronutrientsQuery__
 *
 * To run a query within a React component, call `useMicronutrientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicronutrientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicronutrientsQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useMicronutrientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MicronutrientsQuery, MicronutrientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MicronutrientsQuery, MicronutrientsQueryVariables>(MicronutrientsDocument, options);
      }
export function useMicronutrientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MicronutrientsQuery, MicronutrientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MicronutrientsQuery, MicronutrientsQueryVariables>(MicronutrientsDocument, options);
        }
export type MicronutrientsQueryHookResult = ReturnType<typeof useMicronutrientsQuery>;
export type MicronutrientsLazyQueryHookResult = ReturnType<typeof useMicronutrientsLazyQuery>;
export type MicronutrientsQueryResult = Apollo.QueryResult<MicronutrientsQuery, MicronutrientsQueryVariables>;
export const NutrientsForQuestionDocument = gql`
    query nutrientsForQuestion($questionId: ID!, $demo: Boolean) {
  nutrientsForQuestion(questionId: $questionId, demo: $demo) {
    id
    name
    value
    rda
    unit
    personalRda
    geneDataGroups
    sources {
      name
      sortOrder
      isVegan
      isVegeterian
      isPescatarian
    }
  }
}
    `;

/**
 * __useNutrientsForQuestionQuery__
 *
 * To run a query within a React component, call `useNutrientsForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsForQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useNutrientsForQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NutrientsForQuestionQuery, NutrientsForQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NutrientsForQuestionQuery, NutrientsForQuestionQueryVariables>(NutrientsForQuestionDocument, options);
      }
export function useNutrientsForQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NutrientsForQuestionQuery, NutrientsForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NutrientsForQuestionQuery, NutrientsForQuestionQueryVariables>(NutrientsForQuestionDocument, options);
        }
export type NutrientsForQuestionQueryHookResult = ReturnType<typeof useNutrientsForQuestionQuery>;
export type NutrientsForQuestionLazyQueryHookResult = ReturnType<typeof useNutrientsForQuestionLazyQuery>;
export type NutrientsForQuestionQueryResult = Apollo.QueryResult<NutrientsForQuestionQuery, NutrientsForQuestionQueryVariables>;
export const NutrientsToDecreaseDocument = gql`
    query nutrientsToDecrease($demo: Boolean) {
  nutrientsToDecrease(demo: $demo) {
    id
    name
    personalRda
    rda
    unit
    value
    geneDataGroups
    sources {
      name
      sortOrder
      isVegan
      isVegeterian
      isPescatarian
    }
  }
}
    `;

/**
 * __useNutrientsToDecreaseQuery__
 *
 * To run a query within a React component, call `useNutrientsToDecreaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsToDecreaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsToDecreaseQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useNutrientsToDecreaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NutrientsToDecreaseQuery, NutrientsToDecreaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NutrientsToDecreaseQuery, NutrientsToDecreaseQueryVariables>(NutrientsToDecreaseDocument, options);
      }
export function useNutrientsToDecreaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NutrientsToDecreaseQuery, NutrientsToDecreaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NutrientsToDecreaseQuery, NutrientsToDecreaseQueryVariables>(NutrientsToDecreaseDocument, options);
        }
export type NutrientsToDecreaseQueryHookResult = ReturnType<typeof useNutrientsToDecreaseQuery>;
export type NutrientsToDecreaseLazyQueryHookResult = ReturnType<typeof useNutrientsToDecreaseLazyQuery>;
export type NutrientsToDecreaseQueryResult = Apollo.QueryResult<NutrientsToDecreaseQuery, NutrientsToDecreaseQueryVariables>;
export const NutrientsToIncreaseDocument = gql`
    query nutrientsToIncrease($demo: Boolean) {
  nutrientsToIncrease(demo: $demo) {
    id
    name
    personalRda
    rda
    unit
    value
    geneDataGroups
    sources {
      name
      sortOrder
      isVegan
      isVegeterian
      isPescatarian
    }
  }
}
    `;

/**
 * __useNutrientsToIncreaseQuery__
 *
 * To run a query within a React component, call `useNutrientsToIncreaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsToIncreaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsToIncreaseQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useNutrientsToIncreaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NutrientsToIncreaseQuery, NutrientsToIncreaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NutrientsToIncreaseQuery, NutrientsToIncreaseQueryVariables>(NutrientsToIncreaseDocument, options);
      }
export function useNutrientsToIncreaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NutrientsToIncreaseQuery, NutrientsToIncreaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NutrientsToIncreaseQuery, NutrientsToIncreaseQueryVariables>(NutrientsToIncreaseDocument, options);
        }
export type NutrientsToIncreaseQueryHookResult = ReturnType<typeof useNutrientsToIncreaseQuery>;
export type NutrientsToIncreaseLazyQueryHookResult = ReturnType<typeof useNutrientsToIncreaseLazyQuery>;
export type NutrientsToIncreaseQueryResult = Apollo.QueryResult<NutrientsToIncreaseQuery, NutrientsToIncreaseQueryVariables>;
export const OverviewDocument = gql`
    query Overview($demo: Boolean) {
  overview(demo: $demo) {
    caffeine
    lactose
    gluten
  }
}
    `;

/**
 * __useOverviewQuery__
 *
 * To run a query within a React component, call `useOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OverviewQuery, OverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OverviewQuery, OverviewQueryVariables>(OverviewDocument, options);
      }
export function useOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OverviewQuery, OverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OverviewQuery, OverviewQueryVariables>(OverviewDocument, options);
        }
export type OverviewQueryHookResult = ReturnType<typeof useOverviewQuery>;
export type OverviewLazyQueryHookResult = ReturnType<typeof useOverviewLazyQuery>;
export type OverviewQueryResult = Apollo.QueryResult<OverviewQuery, OverviewQueryVariables>;
export const QuestionsForDataGroupByTypeDocument = gql`
    query questionsForDataGroupByType($types: [GeneDataGroupType!]!, $demo: Boolean) {
  questionsForDataGroupByType(types: $types, demo: $demo) {
    id
    question
    feedbackType
    genestoryId
    geneDataGroupId
  }
}
    `;

/**
 * __useQuestionsForDataGroupByTypeQuery__
 *
 * To run a query within a React component, call `useQuestionsForDataGroupByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsForDataGroupByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsForDataGroupByTypeQuery({
 *   variables: {
 *      types: // value for 'types'
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useQuestionsForDataGroupByTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuestionsForDataGroupByTypeQuery, QuestionsForDataGroupByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuestionsForDataGroupByTypeQuery, QuestionsForDataGroupByTypeQueryVariables>(QuestionsForDataGroupByTypeDocument, options);
      }
export function useQuestionsForDataGroupByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuestionsForDataGroupByTypeQuery, QuestionsForDataGroupByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuestionsForDataGroupByTypeQuery, QuestionsForDataGroupByTypeQueryVariables>(QuestionsForDataGroupByTypeDocument, options);
        }
export type QuestionsForDataGroupByTypeQueryHookResult = ReturnType<typeof useQuestionsForDataGroupByTypeQuery>;
export type QuestionsForDataGroupByTypeLazyQueryHookResult = ReturnType<typeof useQuestionsForDataGroupByTypeLazyQuery>;
export type QuestionsForDataGroupByTypeQueryResult = Apollo.QueryResult<QuestionsForDataGroupByTypeQuery, QuestionsForDataGroupByTypeQueryVariables>;
export const ResilienceDocument = gql`
    query resilience($demo: Boolean) {
  resilience(demo: $demo) {
    emotion
    impulsiveness
    stress
  }
}
    `;

/**
 * __useResilienceQuery__
 *
 * To run a query within a React component, call `useResilienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResilienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResilienceQuery({
 *   variables: {
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useResilienceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResilienceQuery, ResilienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResilienceQuery, ResilienceQueryVariables>(ResilienceDocument, options);
      }
export function useResilienceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResilienceQuery, ResilienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResilienceQuery, ResilienceQueryVariables>(ResilienceDocument, options);
        }
export type ResilienceQueryHookResult = ReturnType<typeof useResilienceQuery>;
export type ResilienceLazyQueryHookResult = ReturnType<typeof useResilienceLazyQuery>;
export type ResilienceQueryResult = Apollo.QueryResult<ResilienceQuery, ResilienceQueryVariables>;
export const StoryRecommendationForQuestionDocument = gql`
    query storyRecommendationForQuestion($questionId: ID!, $demo: Boolean) {
  storyRecommendationForQuestion(questionId: $questionId, demo: $demo) {
    text
    result
  }
}
    `;

/**
 * __useStoryRecommendationForQuestionQuery__
 *
 * To run a query within a React component, call `useStoryRecommendationForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryRecommendationForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryRecommendationForQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useStoryRecommendationForQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoryRecommendationForQuestionQuery, StoryRecommendationForQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoryRecommendationForQuestionQuery, StoryRecommendationForQuestionQueryVariables>(StoryRecommendationForQuestionDocument, options);
      }
export function useStoryRecommendationForQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoryRecommendationForQuestionQuery, StoryRecommendationForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoryRecommendationForQuestionQuery, StoryRecommendationForQuestionQueryVariables>(StoryRecommendationForQuestionDocument, options);
        }
export type StoryRecommendationForQuestionQueryHookResult = ReturnType<typeof useStoryRecommendationForQuestionQuery>;
export type StoryRecommendationForQuestionLazyQueryHookResult = ReturnType<typeof useStoryRecommendationForQuestionLazyQuery>;
export type StoryRecommendationForQuestionQueryResult = Apollo.QueryResult<StoryRecommendationForQuestionQuery, StoryRecommendationForQuestionQueryVariables>;
export const StorydataForQuestionDocument = gql`
    query storydataForQuestion($questionId: ID!, $demo: Boolean) {
  storydataForQuestion(questionId: $questionId, demo: $demo) {
    description
    genestoryResult
    badImage
    goodImage
  }
}
    `;

/**
 * __useStorydataForQuestionQuery__
 *
 * To run a query within a React component, call `useStorydataForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorydataForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorydataForQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      demo: // value for 'demo'
 *   },
 * });
 */
export function useStorydataForQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StorydataForQuestionQuery, StorydataForQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorydataForQuestionQuery, StorydataForQuestionQueryVariables>(StorydataForQuestionDocument, options);
      }
export function useStorydataForQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorydataForQuestionQuery, StorydataForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorydataForQuestionQuery, StorydataForQuestionQueryVariables>(StorydataForQuestionDocument, options);
        }
export type StorydataForQuestionQueryHookResult = ReturnType<typeof useStorydataForQuestionQuery>;
export type StorydataForQuestionLazyQueryHookResult = ReturnType<typeof useStorydataForQuestionLazyQuery>;
export type StorydataForQuestionQueryResult = Apollo.QueryResult<StorydataForQuestionQuery, StorydataForQuestionQueryVariables>;
export const UserFavouritesDocument = gql`
    query userFavourites {
  userFavourites {
    category
    subcategory
    index
  }
}
    `;

/**
 * __useUserFavouritesQuery__
 *
 * To run a query within a React component, call `useUserFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFavouritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFavouritesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserFavouritesQuery, UserFavouritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserFavouritesQuery, UserFavouritesQueryVariables>(UserFavouritesDocument, options);
      }
export function useUserFavouritesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserFavouritesQuery, UserFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserFavouritesQuery, UserFavouritesQueryVariables>(UserFavouritesDocument, options);
        }
export type UserFavouritesQueryHookResult = ReturnType<typeof useUserFavouritesQuery>;
export type UserFavouritesLazyQueryHookResult = ReturnType<typeof useUserFavouritesLazyQuery>;
export type UserFavouritesQueryResult = Apollo.QueryResult<UserFavouritesQuery, UserFavouritesQueryVariables>;
export const UserInformationDocument = gql`
    query userInformation {
  userinformation {
    id
    firstname
    lastname
    gender
    weight
    dateOfBirth
    height
    ethnicity
    userId
    dietPreference
    email
  }
}
    `;

/**
 * __useUserInformationQuery__
 *
 * To run a query within a React component, call `useUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInformationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInformationQuery, UserInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInformationQuery, UserInformationQueryVariables>(UserInformationDocument, options);
      }
export function useUserInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInformationQuery, UserInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInformationQuery, UserInformationQueryVariables>(UserInformationDocument, options);
        }
export type UserInformationQueryHookResult = ReturnType<typeof useUserInformationQuery>;
export type UserInformationLazyQueryHookResult = ReturnType<typeof useUserInformationLazyQuery>;
export type UserInformationQueryResult = Apollo.QueryResult<UserInformationQuery, UserInformationQueryVariables>;
export const UserreportDocument = gql`
    query userreport {
  userreport {
    id
    orderId
    emailId
  }
}
    `;

/**
 * __useUserreportQuery__
 *
 * To run a query within a React component, call `useUserreportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserreportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserreportQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserreportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserreportQuery, UserreportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserreportQuery, UserreportQueryVariables>(UserreportDocument, options);
      }
export function useUserreportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserreportQuery, UserreportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserreportQuery, UserreportQueryVariables>(UserreportDocument, options);
        }
export type UserreportQueryHookResult = ReturnType<typeof useUserreportQuery>;
export type UserreportLazyQueryHookResult = ReturnType<typeof useUserreportLazyQuery>;
export type UserreportQueryResult = Apollo.QueryResult<UserreportQuery, UserreportQueryVariables>;
export const UserDocument = gql`
    query user($useDemoIfNoReportAvailable: Boolean!) {
  user {
    id
    firstName
    lastName
    emailId
    onboardedAt
    dnaReport(useDemoIfNoReportAvailable: $useDemoIfNoReportAvailable) {
      id
      orderId
      emailId
      emailSent
      isDemo
      reportedAt
      createdAt
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      useDemoIfNoReportAvailable: // value for 'useDemoIfNoReportAvailable'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;